import { FilterType } from "src/api/types";
import {
  PATIENT_FIRST_NAME,
  PATIENT_ID,
  PATIENT_LAST_NAME,
  STATE,
  SUBSCRIPTION_NAME,
} from "src/constants/searchParams";
import { statesMap } from "src/constants/usStates";

export const filters: FilterType[] = [
  {
    name: SUBSCRIPTION_NAME,
    type: "text",
    placeholder: "Subscription",
  },
  {
    name: PATIENT_FIRST_NAME,
    type: "text",
    placeholder: "Patient's first name",
  },
  {
    name: PATIENT_LAST_NAME,
    type: "text",
    placeholder: "Patient's last name",
  },
  {
    name: PATIENT_ID,
    type: "text",
    placeholder: "Patient's ID",
  },
  {
    name: STATE,
    placeholder: "State",
    type: "autocomplete",
    values: Object.values(statesMap),
  },
];
